module.exports = __webpack_public_path__ + "img/tuin_beneden-border.22beb813.png";